export default __webpack_public_path__ + "static/media/ViewTabDisable.22ab7cd3.svg";